/* eslint-disable max-classes-per-file */

import axios from 'axios';

// Define the interface for chat models
class ChatModelStrategy {
  // eslint-disable-next-line class-methods-use-this, no-unused-vars
  fetchResponse(input, modelSettings) {
    throw new Error("Method 'fetchResponse' must be defined.");
  }
}

// Implement a specific strategy for OpenAI models like GPT-3.5, GPT-4, etc.
class OpenAIGPT4Strategy extends ChatModelStrategy {
  // eslint-disable-next-line class-methods-use-this
  async fetchResponse(input, modelSettings) {
    const payload = {
      model: modelSettings.modelVersion,
      temperature: modelSettings.temperature,
      max_tokens: modelSettings.maxTokens,
      messages: [{ role: 'user', content: input }],
    };

    const response = await axios.post(process.env.REACT_APP_OPENAI_API_URL, payload, {
      headers: { Authorization: `Bearer ${process.env.REACT_APP_OPENAI_API_KEY}` },
    });

    return response.data.choices[0].message.content;
  }
}

export { ChatModelStrategy, OpenAIGPT4Strategy };
